<template>
  <div class="info_container">
    <div class="info_header" v-if="isPC">
        <h3 class="info_header_title">举报详情</h3>
        <span class="info_header_back" @click="$router.go(-1)">返回</span>
    </div>
    <div class="info_content_block">
        <div class="info_content_row">
            <span class="content_row_title">被举报人工号：</span>
            <span class="content_row_text">{{ form.byComplaintPersonId }}</span>
        </div>
        <div class="info_content_row">
            <span class="content_row_title">被举报人姓名：</span>
            <span class="content_row_text">{{ form.byComplaintPersonName }}</span>
        </div>
        <div class="info_content_item">
            <div class="content_item_title">被举报人单位：</div>
            <div class="content_item_text">{{ form.byComplaintDept }}</div>
        </div>
        <div class="info_content_item">
            <div class="content_item_title">举报内容：</div>
            <div class="content_item_textarea">{{ form.complaintContent }}</div>
        </div>

        <div class="info_content_show">
            <div class="content_item_title">图片附件：</div>
            <div class="content_show_imgs" v-if="imgList.length == 0">
                <div class="show_imgs_item">暂无图片</div>
            </div>
            <div class="content_show_imgs" v-if="imgList.length != 0">
                <img v-for="(item, index) in imgList" :key="index" :src="item" alt="" class="show_imgs_unit">
            </div>
        </div>

        <div class="info_content_show">
            <div class="content_item_title">文件附件：</div>
            <div class="content_show_imgs" v-if="fileList.length == 0">
                <div class="show_imgs_item">暂无文件</div>
            </div>
            <div class="content_show_imgs" v-if="fileList.length != 0">
                <img v-for="(item, index) in fileList" :key="index" :src="item" alt="" class="show_imgs_unit">
            </div>
        </div>

        <div class="info_content_show">
            <div class="content_item_title">您的信息：</div>
            <span class="info_show_text" v-if="form.info == '2'">未填写</span>
            <div class="info_show_block" v-if="form.info == '1'">
                <div class="info_show_row">
                    <span class="show_row_title">姓名：</span>
                    <span class="show_row_text">{{ form.name }}</span>
                </div>
                <div class="info_show_row">
                    <span class="show_row_title">单位：</span>
                    <span class="show_row_text">{{ form.dept }}</span>
                </div>
                <div class="info_show_row">
                    <span class="show_row_title">手机：</span>
                    <span class="show_row_text">{{ form.phone || '无' }}</span>
                </div>
                <div class="info_show_row">
                    <span class="show_row_title">邮箱：</span>
                    <span class="show_row_text">{{ form.email || '无' }}</span>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Info',
    data() {
        return {
            guid:'',
            form:'',
            imgList:[],
            fileList:[],
			isPC: window.innerWidth >= 769
        }
    },

    created(){
        let infoGuid = this.$route.query.guid
        this.getInfoDetail(infoGuid)
    },

    methods: {
        //获取详情信息
        getInfoDetail(guid){
            this.$http.get('/api/ts/v0.1/complaint/'+guid)
            .then(res=>{
                console.log(res)
                this.form = res.data
                if(this.form.imgs){
                    this.imgList = this.form.imgs.split(',')
                }else{
                    this.imgList = []
                }

                if(this.form.files){
                    this.fileList = this.form.files.split(',')
                }else{
                    this.fileList = []
                }
            })
        },
    }
}
</script>

<style scoped lang='less'>
    .info_container{
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        background-color: #f2f2f2;
    }
    .info_header{
        width: 100%;
        height: 50px;
        background-color: white;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #f2f2f2;
    }
    .info_header_title{
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
    .info_header_back{
        font-size: 14px;
        color: #44baff;
        cursor: pointer;
    }
    .info_content_block{
        width: 100%;
        position: absolute;
        left: 0;
        top: 50px;
        bottom: 0;
        background-color: white;
        padding: 20px;
        box-sizing: border-box;
        overflow-y: scroll;
    }
    .info_content_row{
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #f2f2f2;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .content_row_title{
        display: block;
        font-size: 16px;
        color: #333;
        font-weight: 700;
    }
    .content_row_text{
        display: block;
        font-size: 16px;
        color: #666;
        margin-left: 10px;
    }
    .info_content_item{
        width: 100%;
        height: auto;
        border-bottom: 1px solid #f2f2f2;
    }
    .content_item_title{
        width: 100%;
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 16px;
        color: #333;
        font-weight: 700;
    }
    .content_item_text{
        width: 100%;
        height: auto;
        font-size: 16px;
        color: #666;
        line-height: 40px;
        text-align: left;
    }
    .content_item_textarea{
        width: 100%;
        height: auto;
        padding: 10px;
        box-sizing: border-box;
        font-size: 16px;
        color: #666;
        line-height: 24px;
        text-align: left;
    }
    .info_content_show{
        width: 100%;
        height: auto;
        margin-top: 20px;
    }
    .content_show_imgs{
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
    }
    .show_imgs_item{
        width: 100px;
        height: 100px;
        background-color: #f2f2f2;
        margin-left: 10px;
        margin-top: 10px;
        font-size: 16px;
        color: #999;
        line-height: 100px;
    }
    .show_imgs_unit{
        width: 100px;
        height: 100px;
        display: block;
        margin-left: 10px;
        margin-top: 10px;
    }
    .info_show_text{
        display: block;
        font-size: 16px;
        color: #666;
        text-align: left;
        margin-top: 10px;
        margin-bottom: 30px;
    }
    .info_show_block{
        width: 100%;
        height: auto;
        margin-top: 10px;
        margin-bottom: 40px;
    }
    .info_show_row{
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #f2f2f2;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .show_row_title{
        display: block;
        font-size: 16px;
        color: #333;
        font-weight: 700;
    }
    .show_row_text{
        display: block;
        font-size: 16px;
        color: #666;
        margin-left: 10px;
    }

    /* PC端响应式样式 */
    @media (min-width: 769px) {
        .info_container{
            width: 100%;
            height: 100%;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 40px 20px;
            box-sizing: border-box;
        }
        .info_header{
            width: 100%;
            height: auto;
            padding: 6px 20px;
            background: #fff;
            position: relative;
            margin-bottom: 10px;
            border: none;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 4px;
                bottom: 4px;
                width: 4px;
                background-color: #027cfb;
                border-radius: 0 6px 6px 0;
            }
        }
        .info_header_title{
            font-size: 22px;
            color: #333;
        }
        .info_header_back{
            font-size: 20px;
            color: #0169ff;
            cursor: pointer;
            &:hover{
                text-decoration: underline;
            }
        }
        .info_content_block{
            width: 100%;
            height: 100%;
            position: initial;
            background-color: #fff;
            border-top: 1px solid #999;
            padding: 28px 36px;
            overflow-y: auto;
            font-size: 18px;
        }
        .info_content_row{
            height: auto;
            min-height: 40px;
            padding: 10px 0;
            border-bottom: none;
        }
        .content_row_title{
            font-size: 18px;
            color: #333;
            font-weight: 700;
            margin-right: 8px;
        }
        .content_row_text{
            font-size: 18px;
            color: #666;
            font-weight: 500;
        }
        .info_content_item{
            border-bottom: none;
            padding: 10px 0;
        }
        .content_item_title{
            height: auto;
            font-size: 18px;
            color: #333;
            font-weight: 700;
            margin-bottom: 6px;
        }
        .content_item_text{
            font-size: 18px;
            color: #666;
            line-height: 22px;
        }
        .content_item_textarea{
            font-size: 18px;
            color: #666;
            border-radius: 4px;
        }
        .info_content_show{
            margin-top: 16px;
            padding-top: 16px;
            border-top: 1px solid #ebeef5;
        }
        .show_imgs_unit{
            width: 120px;
            height: 120px;
            border-radius: 4px;
            object-fit: cover;
        }
        .show_imgs_item{
            width: auto;
            height: auto;
            min-width: 100px;
            min-height: 100px;
            background-color: #f5f7fa !important;
            background: none;
            margin: 0;
            font-size: 18px;
            color: #999;
        }
        .info_show_text{
            font-size: 18px;
        }
        .info_show_row{
            height: auto;
            min-height: 36px;
            border-bottom: none;
            padding: 6px 0;
        }
        .show_row_title{
            font-size: 18px;
            color: #333;
            font-weight: 700;
            margin-right: 8px;
        }
        .show_row_text{
            font-size: 18px;
            color: #666;
            font-weight: 500;
        }
    }
</style>